import ConvenioShow from './ConvenioShow'
export {ConvenioShow}
export default ConvenioShow
